import { createSelector, createFeatureSelector } from "@ngrx/store";
import { SettingState } from "./setting.reducer";

export const selectSpinner = createSelector(
  createFeatureSelector<SettingState>('settingState'),
  (settingState: SettingState) => {
      return settingState.isLoading;
  }
)

export const selectModalConfirm = createSelector(
  createFeatureSelector('settingState'),
  (settingState: SettingState) => {
      return settingState.modalConfirm;
  }
)

export const selectAlert = createSelector(
  createFeatureSelector('settingState'),
  (settingState: SettingState) => {
      return settingState.alert;
  }
)
